import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { createProvider } from "./vue-apollo";
import { library as faLibrary } from "@fortawesome/fontawesome-svg-core";
import {
  faChartLine,
  faClipboardCheck,
  faCogs,
  faHome,
  faNotEqual,
  faPlus,
  faSearch,
  faTasks,
  faUniversity
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import numeral from "numeral";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import "./index.css";

Vue.config.productionTip = false;

faLibrary.add(faChartLine, faClipboardCheck, faCogs, faHome, faNotEqual, faPlus, faSearch, faTasks, faUniversity);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.filter("formatMoney", function (value) {
  return numeral(value).format("0,0.00")
})

Vue.use(Antd);

fetch("/config/config.json").then(async (response) => {
  const config = await response.json();
  window.$tameoConfig = config;

  new Vue({
    router,
    apolloProvider: createProvider(),
    render: (h) => h(App),
  }).$mount("#app");
});
